export default {
    SET_LOAD(state, isLoaded) {
        state.isLoaded = isLoaded
    },

    PROCCESS_DATA(state, data) {
        state.clients = Object.assign({ ...state.clients }, { ...data.clients })
        state.workedServerCount = data.workedServerCount || 0
        state.servers = data.servers
    }
}
